export enum ActionState {
  available = 'available',
  deprecated = 'deprecated',
  deleted = 'deleted',
}
